import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import config from '../../config.js';
import UserContext from './UserContext.js';
// css
import '../../assets/css/App.css';

// reactstrap
import {Col, Row} from 'reactstrap';

// timezone
import '@progress/kendo-date-math/tz/all';
import {ZonedDate} from '@progress/kendo-date-math';

// multilingual
import {
    downtimeEndKey,
    systemMaintenanceKey,
    mainMessages,
    downtimeStartKey,
    downtimeTextKey
} from '../../assets/text/MultilingualText.js';
import Alert from "./Alert";
import {useLocalization} from "@progress/kendo-react-intl";

const Downtime = (props) => {
    const {
        siteLanguageDefault,
        globalConfig,
    } = useContext(UserContext);
    const localization = useLocalization();

    const [showDowntime, setShowDowntime] = useState(false);
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');

    const kendoDateFix = (dateString) => dateString.replace('Dev', 'Dec')

    useEffect(() => {

        let banner = globalConfig?.banners
        if (banner?.length > 0) {
            setShowDowntime(true);
            if (banner[0]?.start_date != null && banner[0]?.end_date != null) {
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                const parseDate = (dateValue) => {
                    if (!dateValue) return null;

                    // ISO string e.g. "2026-08-13T14:00:00.000Z" - strip timezone and treat as UTC
                    if (typeof dateValue === 'string' && (dateValue.includes('T') || dateValue.endsWith('Z'))) {
                        const stripped = dateValue.split('T')[0] + ' ' + dateValue.split('T')[1].replace(/Z$/, '').split('+')[0].split('-')[0];
                        return new Date(stripped + ' UTC');
                    }

                    // Plain UTC string e.g. "2026-08-13 14:00:00" - append UTC
                    return new Date(dateValue + ' UTC');
                }

                const startUtc = parseDate(banner?.[0]?.start_date);
                const endUtc = parseDate(banner?.[0]?.end_date);

                // toString() automatically converts UTC Date to user's local time with abbreviated timezone
                if (startUtc && !isNaN(startUtc)) {
                    const formatted = startUtc.toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false,
                        timeZoneName: 'short'
                    });
                    setStart(kendoDateFix(formatted.replace(/([A-Z]{2,5})$/, '($1)')));
                }

                if (endUtc && !isNaN(endUtc)) {
                    const formatted = endUtc.toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false,
                        timeZoneName: 'short'
                    });
                    setEnd(kendoDateFix(formatted.replace(/([A-Z]{2,5})$/, '($1)')));
                }
            } 
            else {
                setStart('');
                setEnd('');
            }
        }
    }, [globalConfig]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {showDowntime && (<Row className="justify-content-md-center k-mb-4">
                <Col
                    xs="7"
                    md="auto"
                    style={{maxWidth: '40%'}}
                >
                    <Alert
                        type={'system'}
                        title={globalConfig?.banners?.[0]?.prompt_title}
                        message={
                            <>
                                <div dangerouslySetInnerHTML={{__html: globalConfig?.banners?.[0]?.prompt_message}} />
                                {start && end && (
                                    <div>
                                        <div>
                                            Start of Downtime: {start}
                                        </div>
                                        <div>
                                            End of Downtime: {end}
                                        </div>
                                    </div>
                                )}
                            </>
                        }
                    />
                </Col>
            </Row>)
            }
        </>
    );
}

export default Downtime;
